export default "__VITE_ASSET__c9YTX5FL__"